import {FaqNodeDto} from './faqNodeDto';
import {FaqNodeType} from './faqNodeType';
import {Contact, ContactType} from '../operator/frontEndConfig';
import {I18nFileFrontDto} from '../i18n/i18nFileFrontDto';

export interface FaqNodeDetailDto extends FaqNodeDto {
    ancestors: FaqNodeDto[];
    orderIndex: number;
}

export interface FaqPageDetailDto extends FaqNodeDetailDto {
    content: string;
    contact?: FaqPageContactDto;
    attachedFile?: I18nFileFrontDto;
}

export interface FaqFolderDetailDto extends FaqNodeDetailDto {
    children: FaqNodeDto[];
}

export interface FaqPageContactDto extends Contact {
    '@type': 'faqSupportContact';
}

export function isFaqPageDetail(faqNodeDetail: FaqNodeDetailDto): faqNodeDetail is FaqPageDetailDto {
    return faqNodeDetail && faqNodeDetail['@type'] === FaqNodeType.PAGE;
}

export function isFaqFolderDetail(faqNodeDetail: FaqNodeDetailDto): faqNodeDetail is FaqFolderDetailDto {
    return faqNodeDetail && faqNodeDetail['@type'] === FaqNodeType.FOLDER;
}
